<template>
  <div class="container">
    <div class="box-container">
      <div class="back-btn">
        <a href="javascript:history.back();">&laquo; Back To All Clubs</a>

        <div class="info-container" v-if="club">
          <div class="info-item">
            <b>Club:</b>
            {{ club.name }}
          </div>
        </div>
      </div>

      <table>
        <tr>
          <th>
            <button
              class="loadmore favorites"
              @click="showFavorites = !showFavorites"
            >
              Show <br />
              {{ !showFavorites ? "favorites" : "all" }}
            </button>
          </th>
          <th
            style="cursor: pointer"
            @click="order == 'asc' ? (order = 'desc') : (order = 'asc')"
          >
            Name {{ order == "asc" ? "&#9650;" : "&#9660;" }}
          </th>
          <th>
            <select v-model="gradYear" class="table-select">
              <option value>Grad Year</option>
              <option value="2020">2020</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
              <option value="2026">2026</option>
            </select>
          </th>

          <th>
            <select v-model="position" class="table-select">
              <option value>Position</option>
              <option
                v-for="(position, index) in positions"
                :value="position.ref"
                :key="index"
              >
                {{ position.name }}
              </option>
            </select>
          </th>

          <th>High School</th>
          <th>Club Jersey Number</th>
          <th>
            <span>Interest</span>
            <br />
            <select v-model="interested" class="table-select interested">
              <option value>All</option>
              <option value="yes">Yes</option>
            </select>
          </th>
          <th>
            Commited
            <br />College
          </th>
        </tr>
        <template v-if="athletesRegistered.length > 0">
          <tr
            v-for="(athlete, index) in athletesRegistered"
            :key="index"
            :class="[
              {
                commited:
                  athlete.interestedColleges &&
                  athlete.interestedColleges.length > 0 &&
                  athlete.interested,
              },
              { premium: athlete.receipt },
            ]"
          >
            <td class="star-icon" :class="{ favourited: athlete.favourited }">
              <img
                src="../assets/icons/star.png"
                @click="
                  athlete.favourited
                    ? removeFromFavorites(athlete.ref)
                    : addToFavorites(athlete.ref)
                "
              />
            </td>
            <td>
              <a @click="$router.push(`/athletes/${athlete.id}`)"
                >{{ athlete.lastName }}, {{ athlete.firstName }}</a
              >
            </td>
            <td class="gradYear">{{ athlete.graduatingYear }}</td>
            <td class="position">
              {{ athlete.positionObject ? athlete.positionObject.name : "" }}
            </td>
            <td>
              <a
                v-if="athlete.highSchoolObject"
                @click="
                  $router.push(`/highSchools/${athlete.highSchoolObject.id}`)
                "
                >{{ athlete.highSchoolObject.name }}</a
              >
            </td>
            <td>{{ athlete.clubJerseyNumber }}</td>
            <td v-if="athlete.interestedColleges">
              {{ athlete.interested ? "Yes" : "No" }}
            </td>
            <td>
              <a v-if="athlete.committedCollegeObject">{{
                athlete.committedCollegeObject.name
              }}</a>
            </td>
          </tr>
        </template>
      </table>
      <h2 v-if="athletesRegistered.length <= 0 && executed">
        No athletes attending
      </h2>
    </div>
  </div>
</template>

<script>
import { db } from "../db";
import firebase from "firebase/app";
export default {
  data() {
    return {
      club: null,
      clubRef: null,
      athletesRegistered: [],
      positions: [],
      order: "asc",
      searchInput: "",
      interested: "",
      baseQuery: null,
      currentQuery: null,
      executed: false,
      showFavorites: false,
      force: false,
    };
  },
  computed: {
    gradYear: {
      get() {
        return this.$store.state.gradYear;
      },
      set(value) {
        this.$store.commit("setGradYear", value);
      },
    },
    position: {
      get() {
        return this.$store.state.position;
      },
      set(value) {
        this.$store.commit("setPosition", value);
      },
    },
  },
  created() {
    db.collection("clubTeams")
      .doc(this.$route.params.id)
      .get()
      .then((club) => {
        this.clubRef = club.ref;
        this.club = club.data();

        this.baseQuery = db
          .collection("athletes")
          .where("club", "==", this.clubRef);

        this.executeQuery();

        db.collection("positions")
          .get()
          .then((snap) => {
            this.positions = snap.docs.map((position) => {
              return {
                name: position.data().name,
                ref: position.ref,
              };
            });
          });
      });
  },
  methods: {
    queryBuilder() {
      this.currentQuery = this.baseQuery.orderBy("searchName", this.order);

      if (this.showFavorites) {
        this.currentQuery = this.currentQuery.where(
          "usersFavorited",
          "array-contains",
          this.$store.state.coach.ref
        );
      }

      if (this.gradYear !== "" && this.gradYear !== null) {
        this.currentQuery = this.currentQuery.where(
          "graduatingYear",
          "==",
          parseInt(this.gradYear, 10)
        );
      }

      if (this.position !== "" && this.position !== null) {
        this.currentQuery = this.currentQuery.where(
          "position",
          "==",
          this.position
        );
      }

      if (this.interested && this.interested == "yes") {
        this.currentQuery = this.currentQuery.where(
          "interestedColleges",
          "array-contains",
          this.$store.state.coach.college
        );
      }
    },
    executeQuery() {
      this.queryBuilder();
      this.executed = false;

      this.currentQuery.get().then((snap) => {
        this.executed = true;
        this.athletesRegistered = snap.docs
          .filter((athlete) => athlete.data().graduatingYear > 2019)
          .map((doc) => {
            let interested = false;
            let favourited = false;

            if (doc.data().interestedColleges) {
              if (
                doc
                  .data()
                  .interestedColleges.map((college) => college.id)
                  .includes(this.$store.state.coach.college.id)
              ) {
                interested = true;
              }
            }

            if (
              this.$store.state.coach.favoritedUsers &&
              this.$store.state.coach.favoritedUsers.find(
                (athlete) => athlete.path == doc.ref.path
              )
            ) {
              favourited = true;
            }

            return {
              ref: doc.ref,
              ...doc.data(),
              id: doc.id,
              interested,
              favourited,
            };
          });
      });
    },
    addToFavorites(athleteRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          favoritedUsers: firebase.firestore.FieldValue.arrayUnion(athleteRef),
        })
        .then((res) => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              let updatedAthletes = this.athletesRegistered.map((athlete) => {
                let favourited = false;
                if (
                  this.$store.state.coach.favoritedUsers &&
                  this.$store.state.coach.favoritedUsers.find(
                    (favAthlete) => favAthlete.path == athlete.ref.path
                  )
                ) {
                  favourited = true;
                }
                return { ...athlete, favourited };
              });
              this.$set(this, "athletesRegistered", updatedAthletes);
            });
        });
    },
    removeFromFavorites(athleteRef) {
      db.collection("coaches")
        .doc(this.$store.state.coach.id)
        .update({
          favoritedUsers: firebase.firestore.FieldValue.arrayRemove(athleteRef),
        })
        .then(() => {
          this.$store
            .dispatch("getCoachDoc", this.$store.state.coach.id)
            .then(() => {
              let updatedAthletes = this.athletesRegistered.map((athlete) => {
                let favourited = false;
                if (
                  this.$store.state.coach.favoritedUsers &&
                  this.$store.state.coach.favoritedUsers.find(
                    (favAthlete) => favAthlete.path == athlete.ref.path
                  )
                ) {
                  favourited = true;
                }
                return { ...athlete, favourited };
              });
              this.$set(this, "athletesRegistered", updatedAthletes);
            });
        });
    },
  },
  watch: {
    order() {
      this.executeQuery();
    },
    gradYear() {
      this.executeQuery();
    },
    position() {
      this.executeQuery();
    },
    interested(newValue, oldValue) {
      if (!oldValue && newValue && this.showFavorites) {
        this.force = "interested";
        this.showFavorites = false;
      }

      if (!this.showFavorites || this.force != "favorites") {
        this.executeQuery();
      }
    },
    showFavorites(newValue, oldValue) {
      if (!oldValue && newValue && this.interested == "yes") {
        this.force = "favorites";
        this.interested = "";
      }

      if (this.interested != "yes" || this.force != "interested") {
        this.executeQuery();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  text-align: center;
  margin-top: 50px;
}

.club-list ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.club-list ul li {
  width: 20%;
  padding: 22.2px;
  border-right: 1px solid #707070;
  border-bottom: 1px solid #707070;
  text-align: center;
}

.club-list ul li a {
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  color: #1a348d;
  font-weight: normal;
}
</style>